"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themes = exports["default"] = void 0;
var _reactCssThemr = require("react-css-themr");
var _Tabs = _interopRequireDefault(require("./Tabs"));
// themes
require("./themes/DefaultTheme.css");
var DefaultTheme = {
  "tabs": "DefaultTheme__tabs___2jEX3",
  "selectWithArrows": "DefaultTheme__selectWithArrows___1PB33",
  "tab": "DefaultTheme__tab___3pKCP",
  "selected": "DefaultTheme__selected___Di4E3",
  "tablist": "DefaultTheme__tablist___3BEUZ",
  "disabled": "DefaultTheme__disabled___14VI5",
  "bar": "DefaultTheme__bar___2USgS",
  "no-stretch": "DefaultTheme__no-stretch___3_R_k",
  "vertical": "DefaultTheme__vertical___31Ykv",
  "tabpanel": "DefaultTheme__tabpanel___3TTT7",
  "small": "DefaultTheme__small___3MPMV",
  "secondary": "DefaultTheme__secondary___12uId",
  "noStretch": "DefaultTheme__no-stretch___3_R_k"
};
require("./themes/DarkTheme.css");
var DarkTheme = {
  "tabs": "DarkTheme__tabs___1JtiU",
  "tab": "DarkTheme__tab___qnMgu",
  "selected": "DarkTheme__selected___2T8kN",
  "secondary": "DarkTheme__secondary___aorrY",
  "vertical": "DarkTheme__vertical___1-kcw",
  "small": "DarkTheme__small___3sW4N"
};
require("./themes/LumeTheme.css");
var LumeTheme = {
  "tabs": "LumeTheme__tabs___3x6aB"
};
var themes = exports.themes = {
  DefaultTheme: DefaultTheme,
  DarkTheme: DarkTheme,
  LumeTheme: LumeTheme
};
var ThemedComponent = (0, _reactCssThemr.themr)('Tabs', themes.DefaultTheme)(_Tabs["default"]);
ThemedComponent.displayName = 'Tabs';
ThemedComponent.themes = themes;
var _default = exports["default"] = ThemedComponent;
//# sourceMappingURL=index.js.map